import React from 'react';

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-image" />
    </div>
  );
};

export default Footer;
